'use strict';

var GridMdReoptButtonDirective = function GridMdReoptButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-md-reopt-button.html'),
    controller: 'GridMdReoptButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        $scope.onRowSelectionChanged(event, selectedRows);
      });
    }
  };
};
GridMdReoptButtonDirective.$inject = [];
module.exports = GridMdReoptButtonDirective;